import { useState, useEffect } from 'react';
import { Pane, Card, Heading, Button, majorScale, TextInputField, toaster } from 'evergreen-ui';
import { EditIcon, CircleArrowLeftIcon, ConfirmIcon } from 'evergreen-ui';
import VolunteersTable from './VolunteersTable';
import VolunteerAttendance from './VolunteerAttendance';
import { getVolunteers, addVolunteer } from '../services/volunteersServices';

const Volunteers = ({volunteers, setVolunteers, isDirector }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [newVolunteer, setNewVolunteer] = useState({ nome: '', cognome: '', data_nascita: '' });

    useEffect(() => {
        const fetchVolunteers = async () => {
            try {
                const data = await getVolunteers();
                setVolunteers(data || []);
            } catch (error) {
                console.error('Errore nel recupero dei volontari:', error);
            }
        };

        fetchVolunteers();
    }, []);

    const handleExitEditMode = () => {
        setIsEditing(false);
    };

    const handleAddVolunteer = async () => {
        if (!newVolunteer.nome || !newVolunteer.cognome || !newVolunteer.data_nascita) {
            toaster.warning('Compila tutti i campi richiesti!');
            return;
        }

        try {
            const added = await addVolunteer(newVolunteer);
            if(added.success) {
                const data = await getVolunteers();
                setVolunteers(data || []);
                setNewVolunteer({ nome: '', cognome: '', data_nascita: '' });
                toaster.success('Volontario aggiunto con successo.');
            } else {
                toaster.danger('Errore in aggiunta del nuovo volontario.');
            }
        } catch (error) {
            console.error('Errore durante l\'aggiunta del volontario:', error);
            toaster.danger('Errore durante l\'aggiunta del volontario.');
        }
    };

    if (!isDirector) {
        return (
            <Card elevation={2} padding={24} marginBottom={32} background="tint1">
                <VolunteerAttendance volunteers={volunteers} />
            </Card>
        );
    }

    if (!isEditing) {
        return (
            <Card elevation={2} padding={24} marginBottom={32} background="tint1">
                <Heading size={700} marginBottom={16}>
                    Volontari
                </Heading>
                <VolunteersTable
                    volunteers={volunteers}
                    setVolunteers={setVolunteers}
                    isEditing={false}
                />
                
                <Button appearance="primary" intent="success" marginTop={16} onClick={() => setIsEditing(true)}>
                    Modifica volontari<EditIcon marginLeft={8} />
                </Button>

                <Pane marginTop={32}>
                    <VolunteerAttendance volunteers={volunteers} />
                </Pane>
            </Card>
        );
    }

    return (
        <Pane>
            <Card elevation={2} padding={24} marginBottom={32} background="tint1">
                <Heading size={700} marginBottom={16}>
                    Gestione volontari
                </Heading>
                <VolunteersTable
                    volunteers={volunteers}
                    setVolunteers={setVolunteers}
                    isEditing={true}
                    isDirector={isDirector}
                />

                <Card elevation={1} padding={16} marginTop={24} background="tint2">
                    <Heading size={500} marginBottom={16}>Aggiungi un nuovo volontario</Heading>
                    <TextInputField
                        label="Nome"
                        value={newVolunteer.nome}
                        onChange={(e) => setNewVolunteer(prev => ({...prev, nome: e.target.value}))}
                    />
                    <TextInputField
                        label="Cognome"
                        value={newVolunteer.cognome}
                        onChange={(e) => setNewVolunteer(prev => ({...prev, cognome: e.target.value}))}
                    />
                    <TextInputField
                        label="Data di nascita"
                        type="date"
                        value={newVolunteer.data_nascita}
                        onChange={(e) => setNewVolunteer(prev => ({...prev, data_nascita: e.target.value}))}
                    />
                    <Button appearance="primary" intent="success" onClick={handleAddVolunteer}>
                        Salva volontario <ConfirmIcon marginLeft={8} />
                    </Button>
                </Card>

                <Button appearance="primary" intent="success" marginTop={majorScale(2)} onClick={handleExitEditMode} width="9.1rem">
                    Torna indietro <CircleArrowLeftIcon marginLeft={8} />
                </Button>
            </Card>
        </Pane>
    );
};

export default Volunteers;
